import z from "zod";
import { ZodDateString } from "../zod-types/zod-date-string";

export const substitutionPlanSubmitQuerySchema = z
	.object({
		submit: z.preprocess((val) => {
			if (val === "false") return false;
			if (val === "true") return true;
			return val;
		}, z.boolean()),
		schedule: z.preprocess((val) => {
			if (val === "false") return false;
			if (val === "true") return true;
			return val;
		}, z.boolean()),
		sendEmailsScheduleDate: ZodDateString.optional(),
	})
	.superRefine((value, context) => {
		if (value.schedule) {
			if (!value.sendEmailsScheduleDate) {
				context.addIssue({
					path: ["sendEmailsScheduleDate"],
					code: "custom",
					message: "Required",
				});
			}
		}
	});

export type SubstitutionPlanSubmitQuerySchema = z.infer<typeof substitutionPlanSubmitQuerySchema>;
